import React from 'react';
import { useAdminContext } from './adminContext';
import { AdminConfigModule } from '../../components/admin/AdminConfigModule';

export function AdminConfigurePage() {
  const { adminKey } = useAdminContext();

  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      <AdminConfigModule adminKey={adminKey} />
    </div>
  );
}

export default AdminConfigurePage;
